

const ImageGallery = ({ images, title, className = "" }) => {
    // Only duplicate images for seamless loop if we have multiple images
    // Single images don't need to loop
    const loopImages = images.length > 1 ? [...images, ...images, ...images] : images;

    return (
        <div className={`relative w-full h-full bg-[#050505] ${className}`}>
            <style>{`
                @keyframes marquee-vertical {
                    0% { transform: translateY(0); }
                    100% { transform: translateY(-33.33%); }
                }
                .animate-marquee-vertical {
                    animation: marquee-vertical 20s linear infinite;
                }
                .animate-marquee-vertical:hover {
                    animation-play-state: paused;
                }
            `}</style>

            {/* DESKTOP: Vertical Auto-Scroll Loop */}
            <div className="hidden lg:block w-full h-full overflow-hidden">
                <div className={`w-full hover:cursor-grab active:cursor-grabbing ${images.length > 1 ? 'animate-marquee-vertical' : ''}`}>
                    {loopImages.map((src, index) => (
                        <div key={`v-${index}`} className="w-full p-6 border-b border-white/5">
                            <div className="relative w-full shadow-2xl bg-[#111]">
                                <img
                                    src={src}
                                    alt={`${title} ${index + 1}`}
                                    className="w-full h-auto block opacity-90 hover:opacity-100 transition-opacity duration-500"
                                    loading="lazy"
                                />
                                {/* "Film" Details */}
                                <div className="absolute -bottom-4 -right-2 text-[10px] text-white/20 tracking-widest rotate-90 origin-left">
                                    IMG_{String(index % images.length + 1).padStart(3, '0')}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* MOBILE: Horizontal Manual Scroll */}
            <div className="lg:hidden w-full h-64 sm:h-80 overflow-x-auto snap-x snap-mandatory scrollbar-hide flex items-center bg-[#050505]">
                {images.map((src, index) => (
                    <div key={`h-${index}`} className="flex-shrink-0 w-[85vw] sm:w-[60vw] h-full p-4 snap-center flex items-center justify-center">
                        <div className="relative w-full max-h-full shadow-lg">
                            <img
                                src={src}
                                alt={`${title} ${index + 1}`}
                                className="w-full h-auto max-h-full object-contain block"
                            />
                            <div className="absolute bottom-2 right-2 px-2 py-1 bg-black/50 backdrop-blur text-[10px] text-white/70">
                                {String(index + 1).padStart(2, '0')}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ImageGallery;
